import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Threshold from '../entities/threshold'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface ThresholdState extends ListState<Threshold>{
    editThreshold:Threshold
}
class UserMutations extends ListMutations<Threshold>{

}
class ThresholdModule extends ListModule<ThresholdState,any,Threshold>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Threshold>(),
        loading:false,
        editThreshold:new Threshold()
    }
    actions={
        async getAll(context:ActionContext<ThresholdState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Threshold/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Threshold>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<ThresholdState,any>,payload:any){
            await Ajax.post('/api/services/app/Threshold/Create',payload.data);
        },
        async update(context:ActionContext<ThresholdState,any>,payload:any){
            await Ajax.put('/api/services/app/Threshold/Update',payload.data);
        },
        async delete(context:ActionContext<ThresholdState,any>,payload:any){
            await Ajax.delete('/api/services/app/Threshold/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<ThresholdState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Threshold/GetById?Id='+payload.id);
            return reponse.data.result as Threshold;
        }
    };
    mutations={
        setCurrentPage(state:ThresholdState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:ThresholdState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:ThresholdState,threshold:Threshold){
            
            state.editThreshold=threshold;
            //console.log(state.editFloor);
        }
    }
}
const thresholdModule=new ThresholdModule();
export default thresholdModule;